/* eslint-disable indent */
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import CachedIcon from '@material-ui/icons/Cached';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import HistoryIcon from '@material-ui/icons/History';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import { addDays, format, isSameDay } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { ConfirmationBox } from '../../../components/ConfirmationBox';
import Loading from '../../../components/Loading';
import ProcessFlowModal from '../../../components/ProcessFlowModal';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import colors from '../../../styles/settings/colors';
import { convertForRealFormatted, convertForRealFormattedPrecise } from '../../../utils/convertForRealFormatted';
import { convertNumberPercent } from '../../../utils/convertNumberPercent';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { formatDateTimeToRender, capitalizeFirstLetter } from '../../../utils/functions';
import * as S from './styles';
import moment from 'moment';
import Draggable from 'react-draggable';

const ordersTitle = {
  NumeroNotaFiscal: 'Nota Fiscal',
  Sequencia: 'Sequência',
  DataVencimento: 'Data Vencimento',
  Loja: 'Loja',
};

const ContentContainer = ({ label, value, children, hasTooltip, hasHTML }) => (
  <S.ContentContainer>
    <span className="content-label">{label}</span>
    {hasTooltip ? (
      <Tooltip placement="top-start" title={value || ''}>
        <span className="content-value">
          {value && value.length >= 30 ? `${value.slice(0, 30)}...` : value || ''}
        </span>
      </Tooltip>
    ) : hasHTML ? (
      <span className="content-value" dangerouslySetInnerHTML={value} />
    ) : (
      <span className="content-value">{value || children}</span>
    )}
  </S.ContentContainer>
);

const ValuesPercentContentContainer = ({ label, value, width, children, column, fullWidth }) => (
  <S.ValuesContainer width={width} fullWidth={fullWidth} column={column}>
    <span className="right-label">{label}</span>
    <span className="right-value">{value || children}</span>
  </S.ValuesContainer>
);

function OperationTable({
  provider,
  setAtualizaAbatimentoDesconto,
  setProvider,
  setUpdatedNotes,
  anchorId,
  setScreenControls,
  setProviderInfo,
  providerInfo,
  notesToAdd,
  notesToRemove,
  isLoading,
  setIsLoading,
  setUpdateRightTable,
  setNotesToRemove,
  setNotesToAdd,
  setStatusPropose,
  updateInfo,
  setUpdateInfo,
  setOperationConclusion,
  setOperationConclusionAncora,
  setEmailInteresseConclusao,
  setOpcoesButtons,
  setReloadRightTable
}) {
  const { setMessageData } = useMessageBox();
  const [providerCalc, setProviderCalc] = useState([]);
  const [tax, setTax] = useState('');
  const [amountPay, setAmountPay] = useState('');
  const [desagio, setDesagio] = useState('');
  const [desconto, setDesconto] = useState('')
  const [newCondition, setNewCondition] = useState('Nenhum');
  const [newSequency, setNewSequency] = useState('NumeroNotaFiscal');
  const [open, setOpen] = useState(false);
  const [openProcessFlowModal, setOpenProcessFlowModal] = useState(false);
  const [processFlowAntecipacaoId, setProcessFlowAntecipacaoId] = useState(null);
  const [processFlowFornecedorId, setProcessFlowFornecedorId] = useState(null);
  const [processFlowFornecedorNome, setProcessFlowFornecedorNome] = useState('');
  const [tipoCalculo, setTipoCalculo] = useState('Taxa');
  const [focusTipoCalculo, setFocusTipoCalculo] = useState('Taxa')
  const [calcError, setCalcError] = useState([]);
  const [successSendPropose, setSuccessSendPropose] = useState(false);
  const [inputEnter, setInputEnter] = useState(false);
  const [changedValueTax, setChangedValueTax] = useState(false);
  const [contatoEfetuado, setContatoEfetuado] = useState('')
  const [isSendingOperation, setIsSendingOperation] = useState(false);

  const [confirmationBox, setConfirmationBox] = useState({
    show: false,
    type: '',
    callback: () => {},
  });
  const [confirmationRedeBox, setConfirmationRedeBox] = useState({
    show: false,
    type: '', 
    callback: () => {},
    callbackOptional: () => {},
    labelOptional: '',
    optionalButton: false,
    labelClose: ''
  })
  const taxInput = useRef(null);
  const desagioInput = useRef(null);
  const descontoInput = useRef(null);
  const valInput = useRef(null);


  const fetchByOrigin = async (contatoEfetuadoCheck = false) => {
    setIsLoading(true);
    setSuccessSendPropose(false);
    setStatusPropose(false);
    setOperationConclusion([]);
    setOperationConclusionAncora([]);
    setEmailInteresseConclusao({})

    try {
      //console.log(providerInfo, updateInfo)
      const bodyRequest = {
        antecipacaoId: provider?.antecipacaoId,
        ancoraId: provider?.ancoraId || anchorId,
        fornecedorId: provider?.fornecedorId,
        dataAtualizacao: provider?.dataAtualizacao,
        valorLiquido: provider?.valorLiquido ? provider?.valorLiquido : provider?.valorAntecipacao,
        status: provider?.status,
        situacao: provider?.situacao,
        origem: provider?.origemProv,
      };
      const response = await api.put('OperacoesAntecipacoes/ConsultarAntecipacao', bodyRequest);
     // console.log(response);
      if (response.data.status !== 'Inconsistencia') {
        setCalcError([]);
        setProviderInfo((prevProvider) => ({
          ...prevProvider,
          ...response.data.resposta.operacao,
        }));
        if(contatoEfetuadoCheck) {
          setProvider((provider) => ({
            ...provider,
            ...response.data.resposta.operacao,
          }));
        }
        //console.log(response.data.resposta)
        setProviderCalc(response.data.resposta);
        setUpdatedNotes(response.data.resposta.titulos);
        setScreenControls(response.data.resposta.controlesTela);
        setOperationConclusion([response.data.resposta.conclusao]);
        setOperationConclusionAncora([response.data.resposta.conclusaoAncora]);
        setEmailInteresseConclusao(response.data.resposta.emailInteresseConclusao)
        setMessageData(response?.data?.complemento?.mensagensBox);
      } else {
        setMessageData(response?.data?.complemento?.mensagensBox);
        setCalcError(handleErrorRequest(response));
        setProviderCalc([]);
        setUpdatedNotes([]);
        setScreenControls([]);
        setOperationConclusion({});
        setOperationConclusionAncora({});
        setEmailInteresseConclusao({})
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      setCalcError(handleErrorRequest(error.response));
      setOperationConclusion([]);
      setOperationConclusionAncora([]);
      setEmailInteresseConclusao({})
      setProviderCalc([]);
      setUpdatedNotes([]);
      setScreenControls([]);
    }
    setIsLoading(false);
    setNotesToAdd([]);
    setNotesToRemove([]);
  };

  const setOperantionValues = (response) => {
    setProviderCalc(response.data.resposta);
    setUpdatedNotes(response.data.resposta.titulos);
    setScreenControls(response.data.resposta.controlesTela);
    setNewSequency(response?.data?.resposta?.operacao?.ordemTitulos);
    setNewCondition(response?.data?.resposta?.operacao?.condicao);
    setOperationConclusion([response?.data?.resposta?.conclusao]);
    setOperationConclusionAncora([response?.data?.resposta?.conclusaoAncora]);
    setEmailInteresseConclusao(response?.data?.resposta?.emailInteresseConclusao)
    setMessageData(response?.data?.complemento?.mensagensBox);
  };

  const fetchOperation = async (bodyRequest, updatingNote = false) => {
    setIsLoading(true);
    setSuccessSendPropose(false);
    setOperationConclusion([]);
    setOperationConclusionAncora([]);
    setEmailInteresseConclusao({})
    setStatusPropose(false);
    try {
      const response = await api.post('OperacoesAntecipacoes/CalcularAntecipacao', bodyRequest);
      console.log(response.data.resposta);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        setCalcError([]);
        setProviderInfo((prevProvider) => ({
          ...prevProvider,
          ...response.data.resposta.operacao,
        }));
        // setMessageData(messages);
        setOperantionValues(response);
        setChangedValueTax(false);
        if (updatingNote) setUpdateRightTable(response.data.resposta.operacao);
      } else {
        setCalcError(handleErrorRequest(response));
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      setCalcError(handleErrorRequest(error.response));
    }
    setIsLoading(false);
    setNotesToAdd([]);
    setNotesToRemove([]);
    setFocusTipoCalculo(tipoCalculo)
    if(tipoCalculo === 'Taxa') {
      taxInput?.current?.focus()
    } else if (tipoCalculo === 'Desagio') {
      desagioInput?.current?.focus()
    } else if(tipoCalculo === 'Desconto') {
      descontoInput?.current?.focus()
    }
  };

  const recalculateOperation = (
    backDay = false,
    advancedDay = false,
    updatingNote = false,
    orderTitle = newSequency,
  ) => {
    const calcPaymentDate = new Date(providerCalc?.operacao?.dataPagamento);

    let titulos = [];

    if (notesToAdd != null && notesToAdd?.length > 0) {
      titulos = notesToAdd.map((x) => {
        return {
          adicionarTituloId: x.tituloId,
          removerTituloId: 0,
          dataAtualizacao: x.dataAtualizacao,
        };
      });
    }

    if (notesToRemove != null && notesToRemove?.length > 0) {
      titulos = notesToRemove.map((x) => {
        return {
          adicionarTituloId: 0,
          removerTituloId: x.tituloId,
          dataAtualizacao: x.dataAtualizacao,
        };
      });
    }

    
    let destinoPagamentoId = Number(sessionStorage.getItem("DestinoPagamentoIdAtual") || 2);
    const bodyRequest = {
      antecipacao: {
        antecipacaoId: 0,
        ancoraId: provider?.ancoraId || anchorId,
        fornecedorId: provider?.fornecedorId,
        fornecedorContaBancariaId: 0, // envia 0
        origem: provider?.origemProv, // botao
        condicao: newCondition,
        ordemTitulos: orderTitle,
        situacao: providerCalc.operacao?.antecipacaoSituacao,
        status: providerCalc.operacao?.antecipacaoStatus,
        destinoPagamentoId: destinoPagamentoId,
        emailInteresseId: providerCalc?.operacao?.emailInteresseId, 
        contatoEfetuado: contatoEfetuado ? contatoEfetuado : providerCalc?.operacao?.contatoEfetuado,
      },
      datas: {
        dataBase: format(new Date(), 'yyyy-MM-dd'), // dia de hoje, sem hora
        dataPagamento: format(calcPaymentDate, 'yyyy-MM-dd'), // dia de hoje + 1, sem hora
        avancar: advancedDay,
        retroceder: backDay,
      },
      titulos: titulos,
      calcular: {
        tipoCalculo: tipoCalculo, // Taxa ou Valor
        taxa: tipoCalculo == 'Taxa' ? Number(tax || providerCalc?.operacao?.taxa) : 0,
        valorLiquidoDesejado: 0,
        valorBruto: providerCalc?.operacao?.valorBruto,
        desagio: tipoCalculo == 'Desagio' ? Number(desagio) : 0,
        valorDescontoDesejado: tipoCalculo == 'Desconto' ? Number(desconto) : 0,
        valorTarifa: 0
      },
    };
    fetchOperation(bodyRequest, updatingNote);
  };

  const replaceOperation = async () => {
    const bodyRequest = {
      antecipacaoId: providerCalc.operacao.antecipacaoId,
      ancoraId: provider?.ancoraId || anchorId,
      fornecedorId: providerCalc.operacao?.fornecedorId,
      dataAtualizacao: providerCalc.operacao?.dataAtualizacao || format(new Date(), 'yyyy-MM-dd'),
      valorLiquido: providerCalc.operacao?.valorLiquido,
      situacao: providerCalc.operacao?.antecipacaoSituacao,
      status: providerCalc.operacao?.antecipacaoStatus,
      origem: provider?.origemProv,
      emailInteresseId: providerCalc?.operacao?.emailInteresseId,
    };
    setIsLoading(true);
    try {
      const response = await api.put('OperacoesAntecipacoes/SubstituirAntecipacao', bodyRequest);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Substituição de antecipação realizada com sucesso!');
        setOperantionValues(response);
        setUpdateInfo({ ...updateInfo, canUpdate: true });
        localStorage.setItem('isReplace', updateInfo.origin);
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
    await fetchOpcoesButtons();
    setReloadRightTable(true)
    setIsLoading(false);
  };

  const fecharOperation = () => {
    setAtualizaAbatimentoDesconto(true)
    setProvider('')
    setOperationConclusion([]);
    setOperationConclusionAncora([]);
    setEmailInteresseConclusao({})
    setProviderCalc([]);
    setUpdatedNotes([]);
    setScreenControls([]);
  }

  const cancelOperation = async () => {
    const bodyRequest = {
      antecipacaoId: provider.antecipacaoId,
      ancoraId: provider?.ancoraId || anchorId,
      fornecedorId: provider?.fornecedorId,
      dataAtualizacao: provider.dataAtualizacao ? provider.dataAtualizacao : providerInfo.dataAtualizacao,
      valorLiquido: provider?.valorLiquido ? provider?.valorLiquido : provider?.valorAntecipacao,
      situacao: providerCalc?.operacao?.antecipacaoSituacao,
      status: providerCalc?.operacao?.antecipacaoStatus,
      origem: provider?.origemProv,
    };
    setIsLoading(true);
    try {
      const response = await api.put('OperacoesAntecipacoes/CancelarAntecipacao', bodyRequest);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Cancelamento de antecipação realizada com sucesso!');
        setUpdateInfo({ ...updateInfo, canUpdate: true });
        setOperantionValues(response);
        setStatusPropose(true);
        setSuccessSendPropose(true);
        setAtualizaAbatimentoDesconto(true)
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
    await fetchOpcoesButtons();
    setReloadRightTable(true)
    setIsLoading(false);
  };

  const aplicarAntecipacoesDescontos = async () => {
    const bodyRequest = {
      antecipacaoId: provider.antecipacaoId,
      ancoraId: provider?.ancoraId || anchorId,
      fornecedorId: provider?.fornecedorId,
      dataAtualizacao: provider.dataAtualizacao ? provider.dataAtualizacao : providerInfo.dataAtualizacao,
      valorLiquido: provider?.valorLiquido ? provider?.valorLiquido : provider?.valorAntecipacao,
      situacao: providerCalc?.operacao?.antecipacaoSituacao,
      status: providerCalc?.operacao?.antecipacaoStatus,
      origem: provider?.origemProv,
    };
    setIsLoading(true);
    try {
      const response = await api.put('OperacoesAntecipacoes/AplicarAbatimentosDescontos', bodyRequest);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Desconto aplicado com sucesso!');
        setUpdateInfo({ ...updateInfo, canUpdate: true });
        setCalcError([]);
        setProviderInfo((prevProvider) => ({
          ...prevProvider,
          ...response.data.resposta.operacao,
        }));
        setOperantionValues(response);
        setAtualizaAbatimentoDesconto(true)
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
    setReloadRightTable(true)
    setIsLoading(false);
  };

  const sendOperationRequest = async () => {
    // Proteção contra chamadas duplicadas
    if (isSendingOperation) {
      return;
    }
    
    setIsSendingOperation(true);
    const bodyRequest = {
      titulos: [...providerCalc.titulos.filter((titulo) => titulo.status === 'Disponivel')],
      antecipacao: {
        antecipacaoId: providerCalc?.operacao?.antecipacaoId,
        aplicarAbatimentosDescontosAntecipacaoIdOrigem: providerCalc?.operacao?.aplicarAbatimentosDescontosAntecipacaoIdOrigem,
        ancoraId: providerCalc?.operacao?.ancoraId,
        fornecedorId: providerCalc?.operacao?.fornecedorId,
        fornecedorContaBancariaId: providerCalc?.operacao?.fornecedorContaBancariaId ?? 0, // envia 0
        condicao: newCondition || providerCalc?.operacao?.condicao,
        ordemTitulos: newSequency || providerCalc?.operacao?.ordemTitulos,
        dataBase: providerCalc?.operacao?.dataBase, // dia de hoje, sem hora
        dataPagamento: providerCalc?.operacao?.dataPagamento,
        desagio: providerCalc?.operacao?.desagio,
        prazoMedio: providerCalc?.operacao?.prazoMedio,
        quantidadeTitulos: providerCalc?.operacao?.quantidadeTitulosDisponiveis,
        tipoCalculo: providerCalc?.operacao?.tipoCalculo,
        taxa: providerCalc?.operacao?.taxa,
        valorBruto: providerCalc?.operacao?.valorBruto,
        valorDesconto: providerCalc?.operacao?.valorDesconto,
        valorLiquido: providerCalc?.operacao?.valorLiquido,
        destinoPagamentoId: providerCalc?.operacao?.destinoPagamentoId,
        bancoFidcTaxaBanco: providerCalc?.bancoFidc?.taxaBanco,
        bancoFidcJurosTaxa: providerCalc?.bancoFidc?.jurosTaxa,
        bancoFidcJurosValor: providerCalc?.bancoFidc?.jurosValor,
        bancoFidcIofTaxa: providerCalc?.bancoFidc?.iofTaxa,
        bancoFidcIofValor: providerCalc?.bancoFidc?.iofValor,
        bancoFidcIofDiarioTaxa: providerCalc?.bancoFidc?.iofDiarioTaxa,
        bancoFidcIofDiarioValor: providerCalc?.bancoFidc?.iofDiarioValor,
        bancoFidcValorTarifaBancaria: providerCalc?.bancoFidc?.valorTarifaBancaria,
        bancoFidcCustoEfetivo: providerCalc?.bancoFidc?.custoEfetivo,
        contatoEfetuado: contatoEfetuado ? contatoEfetuado : providerCalc?.operacao?.contatoEfetuado,
        emailInteresseId: providerCalc?.operacao?.emailInteresseId,
      },
    };
    setIsLoading(true);
    try {
      await sendOperation(bodyRequest);
      await fetchOpcoesButtons();
      setAtualizaAbatimentoDesconto(true);
    } finally {
      setIsLoading(false);
      setIsSendingOperation(false);
    }
  };

  const sendOperationRequestRede = async () => {
    // Proteção contra chamadas duplicadas
    if (isSendingOperation) {
      return;
    }
    
    setIsSendingOperation(true);
    const bodyRequest = {
      titulos: [...providerCalc.titulos.filter((titulo) => titulo.status === 'Disponivel')],
      antecipacao: {
        antecipacaoId: providerCalc?.operacao?.antecipacaoId,
        aplicarAbatimentosDescontosAntecipacaoIdOrigem: providerCalc?.operacao?.aplicarAbatimentosDescontosAntecipacaoIdOrigem,
        ancoraId: providerCalc?.operacao?.ancoraId,
        fornecedorId: providerCalc?.operacao?.fornecedorId,
        fornecedorContaBancariaId: providerCalc?.operacao?.fornecedorContaBancariaId ?? 0, // envia 0
        condicao: newCondition || providerCalc?.operacao?.condicao,
        ordemTitulos: newSequency || providerCalc?.operacao?.ordemTitulos,
        dataBase: providerCalc?.operacao?.dataBase, // dia de hoje, sem hora
        dataPagamento: providerCalc?.operacao?.dataPagamento,
        desagio: providerCalc?.operacao?.desagio,
        prazoMedio: providerCalc?.operacao?.prazoMedio,
        quantidadeTitulos: providerCalc?.operacao?.quantidadeTitulosDisponiveis,
        tipoCalculo: providerCalc?.operacao?.tipoCalculo,
        taxa: providerCalc?.operacao?.taxa,
        valorBruto: providerCalc?.operacao?.valorBruto,
        valorDesconto: providerCalc?.operacao?.valorDesconto,
        valorLiquido: providerCalc?.operacao?.valorLiquido,
        destinoPagamentoId: 1,
        bancoFidcTaxaBanco: providerCalc?.bancoFidc?.taxaBanco,
        bancoFidcJurosTaxa: providerCalc?.bancoFidc?.jurosTaxa,
        bancoFidcJurosValor: providerCalc?.bancoFidc?.jurosValor,
        bancoFidcIofTaxa: providerCalc?.bancoFidc?.iofTaxa,
        bancoFidcIofValor: providerCalc?.bancoFidc?.iofValor,
        bancoFidcIofDiarioTaxa: providerCalc?.bancoFidc?.iofDiarioTaxa,
        bancoFidcIofDiarioValor: providerCalc?.bancoFidc?.iofDiarioValor,
        bancoFidcValorTarifaBancaria: providerCalc?.bancoFidc?.valorTarifaBancaria,
        bancoFidcCustoEfetivo: providerCalc?.bancoFidc?.custoEfetivo,
        contatoEfetuado: contatoEfetuado ? contatoEfetuado : providerCalc?.operacao?.contatoEfetuado,
        emailInteresseId: providerCalc?.operacao?.emailInteresseId,
      },
    };
    setIsLoading(true);
    try {
      await sendOperation(bodyRequest);
      await fetchOpcoesButtons();
      setAtualizaAbatimentoDesconto(true);
    } finally {
      setIsLoading(false);
      setIsSendingOperation(false);
    }
  };

  const fetchOpcoesButtons = async () => {
    try {
      const result = await api.get(`OperacoesAntecipacoes/ConsultarQuantidadeNotasDisponiveisTotalizadoPorFrequenciasAntecipacoesAncoras?ancoraId=${anchorId}`)
      if(result && result.data && result.data.status == 'Sucesso') {
        setOpcoesButtons({
          nuncaAntecipouQuantidade: result.data.resposta.nuncaAntecipouQuantidade,
          agendadoQuantidade: result.data.resposta.agendadoQuantidade,
          de1a30Quantidade: result.data.resposta.de1a30Quantidade,
          de31a90Quantidade: result.data.resposta.de31a90Quantidade,
          maior90Quantidade: result.data.resposta.maior90Quantidade,
          interesseQuantidade: result.data.resposta.interesseQuantidade,
          corporateQuantidade: result.data.resposta.corporateQuantidade
        });
      }
    } catch (err) {
      setMessageData(err.response?.data?.complemento?.mensagensBox);
      setOpcoesButtons({
        nuncaAntecipouQuantidade: '',
        agendadoQuantidade: '',
        de1a30Quantidade: '',
        de31a90Quantidade: '',
        maior90Quantidade: '',
        interesseQuantidade: '',
        corporateQuantidade: ''
      });
      console.log(err);
    }
  }

  const sendOperation = async (bodyRequest) => {
    try {
      const response = await api.post('OperacoesAntecipacoes/AdicionarAntecipacao', bodyRequest);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Proposta enviada com sucesso!');
        setUpdateInfo({ ...updateInfo, canUpdate: true });
        setSuccessSendPropose(true);
        setStatusPropose(true);
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
    // Removido setIsLoading(false) daqui pois é controlado pelo sendOperationRequest
  }

  const atualizarContatoEfetuado = async (contatoDate) => {
    setIsLoading(true)
    try {
      const body = {
        ancoraId: providerCalc?.operacao?.ancoraId,
        antecipacaoId: providerCalc.operacao.antecipacaoId ? providerCalc.operacao.antecipacaoId : provider.antecipacaoId,
        contatoEfetuado: contatoDate
      }
      const response = await api.put('OperacoesAntecipacoes/AtualizarContatoEfetuado', body);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
      await fetchByOrigin(true)
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    } finally {
      setIsLoading(false);
    }
  }

  const consultarDataHora = async () => {
    try {
      const response = await api.post('OperacoesAntecipacoes/ConsultarDataHoraAtual');
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        setContatoEfetuado(response.data.resposta)
        return response.data.resposta
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
        return ''
      }
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
      return ''
    }
  }

  const formatDateWithoutHour = (date) => {
    if (date) {
      return formatDateTimeToRender(date)?.split(' ')?.[0];
    }
    return '';
  };

  const handleCloseFIDC = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setOpen(false);
  };

  const handleReload = () => {
    providerCalc.operacao?.antecipacaoId === 0 ? recalculateOperation() : fetchByOrigin();
  };

  const favoritarAncora = async (favorito) => {
    setIsLoading(true);
    try {
      const response = await api.get(`OperacoesAntecipacoes/FavoritarFornecedoresAncoras?ancoraId=${anchorId}&fornecedorId=${provider.fornecedorId}`);
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        if(favorito) {
          toast.success('Proposta desfavoritada com sucesso!');
        } else {
          toast.success('Proposta favoritada com sucesso!');
        }
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
      await fetchOpcoesButtons();
      setReloadRightTable(true)
      providerCalc.operacao?.antecipacaoId === 0 ? loadOperation() : fetchByOrigin();
    } catch (error) {
      setMessageData(error.response?.data?.complemento?.mensagensBox);
      setIsLoading(false);
      handleErrorRequest(error.response);
    }
  }

  /**
   * Pré-validação Épico 4: antes de cancelar/substituir, consulta se há remessa ativa
   * em AntecipacoesPagamentosRemessas e bloqueia se o Status impedir a ação.
   *
   * Bloqueios:
   *  - Cancelamento: bloqueado se Status ∈ {Pendente, Processando, Enviado, Pago, PagoManual}
   *  - Substituição: bloqueado se Status ∈ {Processando, Enviado, Pago, PagoManual}
   *
   * Em caso de Cancelado/Erro/sem remessa, prossegue normalmente.
   * Em caso de falha na consulta, prossegue (o backend é a fonte da verdade e validará novamente).
   */
  const verificarRemessaPagamentoEContinuar = async (acao, callback) => {
    const antId = Number(provider?.antecipacaoId || providerCalc?.operacao?.antecipacaoId || 0);
    if (!antId) {
      callback();
      return;
    }
    try {
      const response = await api.get('AntecipacoesPagamentosRemessas/ConsultarPorAntecipacaoId', {
        params: { antecipacaoId: antId },
      });
      const remessa = response?.data?.resposta;
      if (remessa && (remessa.antecipacaoPagamentoRemessaId ?? remessa.AntecipacaoPagamentoRemessaId)) {
        const status = Number(remessa.status ?? remessa.Status);
        const labels = { 0: 'Pendente', 1: 'Processando', 2: 'Enviado', 3: 'Erro', 4: 'Pago', 5: 'Pago Manual', 6: 'Cancelado' };
        const bloqueiosCancelamento = [0, 1, 2, 4, 5]; // Pendente/Processando/Enviado/Pago/PagoManual
        const bloqueiosSubstituicao = [1, 2, 4, 5]; // Processando/Enviado/Pago/PagoManual
        const bloqueado =
          (acao === 'cancelamento' && bloqueiosCancelamento.includes(status)) ||
          (acao === 'substituicao' && bloqueiosSubstituicao.includes(status));
        if (bloqueado) {
          const labelStatus = labels[status] ?? `Status ${status}`;
          const labelAcao = acao === 'cancelamento' ? 'cancelar' : 'substituir';
          toast.error(
            `Não é possível ${labelAcao} esta antecipação: já existe remessa bancária em "${labelStatus}".`,
          );
          return;
        }
      }
    } catch (error) {
      // Falha de pré-consulta não bloqueia; backend valida novamente.
    }
    callback();
  };

  const handleConfirmationBox = (type, callback) => {
    if (providerCalc?.operacao?.destinoPagamentoId !== 1 && type === 'confirmacao') {
      setConfirmationRedeBox({
        show: true,
        type: 'confirmationRede',
        callback: sendConfirmationDestino,
        callbackOptional: sendConfirmationRede,
        labelOptional: providerCalc?.operacao?.destinoPagamento ? providerCalc?.operacao?.destinoPagamento : 'Destino Pagamento',
        optionalButton: true,
        labelClose: 'cancelar',
        closeBtnLastLayout: true,
      });
    } else {
      setConfirmationBox({
        show: true,
        type,
        callback,
      });
    }
  };

  const sendConfirmationRede = async () => {
    setConfirmationBox({
      show: true,
      type: 'confirmacao',
      callback: sendOperationRequestRede,
    });
  }

  const sendConfirmationDestino = () => {
    setConfirmationBox({
      show: true,
      type: 'confirmacao',
      callback: sendOperationRequest,
    });
  }

  const handleFocus = (e) => {
    // setTimeout(() => {
    //   e.target.select();
    // }, 100);
  };

  const loadOperation = () => {

    let destinoPagamentoId = sessionStorage.getItem("DestinoPagamentoIdAtual") || 2;

    const bodyRequest = {
      antecipacao: {
        antecipacaoId: 0,
        ancoraId: provider?.ancoraId || anchorId,
        fornecedorId: provider?.fornecedorId,
        fornecedorContaBancariaId: 0, // envia 0
        origem: provider.origemProv, // botao
        condicao: 'Nenhum',
        ordemTitulos: 'NumeroNotaFiscal',
        situacao: 'Normal',
        status: 'Pendente',
        emailInteresseId: provider?.emailInteresseId,
        destinoPagamentoId: destinoPagamentoId ? Number(destinoPagamentoId) : 1
      },
      datas: {
        dataBase: format(new Date(), 'yyyy-MM-dd'), // dia de hoje, sem hora
        dataPagamento: format(addDays(new Date(), 1), 'yyyy-MM-dd'), // dia de hoje + 1, sem hora
      },
      titulos: [
        {
          adicionarTituloId: 0,
          removerTituloId: 0,
          dataAtualizacao: '2021-06-04T12:16:35.873Z',
        },
      ],
      calcular: {
        tipoCalculo: 'Taxa', // Taxa ou Valor
        taxa: provider?.ultimaTaxa || provider?.taxa,
        valorLiquidoDesejado: 0,
        valorBruto: provider?.valorBruto,
        desagio: 0,
        valorDescontoDesejado: 0,
        valorTarifa: 0
      },
    };
    fetchOperation(bodyRequest);
  }

  useEffect(() => {
    if (provider && (!provider?.origemProv || provider?.origemProv === 'NotasDisponiveis' || provider?.origemProv === 'Agendamentos')) {
      setFocusTipoCalculo('Taxa')
      setTipoCalculo('Taxa')
      setTax('');
      setCalcError([]);
      loadOperation();
    }
  }, [provider]);

  useEffect(() => {
    setContatoEfetuado('')
    if (provider?.origemProv && provider && provider.antecipacaoId) {
      fetchByOrigin();
    }
  }, [provider]);

  useEffect(() => {
    if (notesToAdd != null && notesToAdd?.length > 0) {
      recalculateOperation(undefined, undefined, true);
    }

    // if (notesToAdd?.tituloId !== 0) {
    //   recalculateOperation(undefined, undefined, true);
    // }
  }, [notesToAdd]);

  useEffect(() => {
    if (notesToRemove != null && notesToRemove?.length > 0) {
      recalculateOperation(undefined, undefined, true);
    }
  }, [notesToRemove]);
  // useEffect(() => {
  //   if (notesToRemove != null && notesToRemove?.length > 0) {
  //     recalculateOperation();
  //   };
  // }, [notesToRemove]);

  // useEffect(() => {
  //   if (notesToAdd != null && notesToAdd?.length > 0) {
  //     recalculateOperation(undefined, undefined, true);
  //   };

  //   // if (notesToAdd?.tituloId !== 0) {
  //   //   recalculateOperation(undefined, undefined, true);
  //   // }
  // }, [notesToAdd]);

  // useEffect(() => {
  //  ;
  //   if (Object.keys(notesToRemove).length === 0 || !notesToRemove) return;
  //   if (notesToRemove?.tituloId !== 0) {
  //     recalculateOperation(undefined, undefined, true);
  //   }
  // }, [notesToRemove]);

  useEffect(() => {
    setOperationConclusion([]);
    setOperationConclusionAncora([]);
    setEmailInteresseConclusao({})
  }, [anchorId]);

  const fetchInfo = async () => {
    try {
      const response = await api.get(
        `OperacoesAntecipacoes/ConsultarInformacoesOperacao?ancoraId=${anchorId}&fornecedorId=${provider.fornecedorId}&antecipacaoId=${providerCalc.operacao.antecipacaoId}&taxa=${providerCalc.operacao.taxa}&valorBruto=${providerCalc.operacao.valorBruto}&valorDesconto=${providerCalc.operacao.valorDesconto}&prazoMedioReal=${providerCalc.operacao.prazoMedioReal}&dataPagamento=${providerCalc.operacao.dataPagamento}`);
        if (response.data.status !== 'Inconsistencia') {
        setConfirmationBox({
          show: true,
          type: 'anchorInfo',
          titulo: 'Informações da Operação',
          htmlText: response.data.resposta,
          callback: () => { },
          closeBtnLastLayout: false,
          labelClose: 'Fechar',
          onlyOneButton: true
        })
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
    } catch (error) {
      setMessageData(error?.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
  }

  const fetchLogsAntecipacoes = async () => {
    try {
      const antecipacaoId = providerCalc?.operacao?.antecipacaoId || provider?.antecipacaoId;
      const fornecedorId = providerCalc?.operacao?.fornecedorId || provider?.fornecedorId;
      const fornecedorNome = providerCalc?.operacao?.fornecedor || provider?.fornecedor || '';
      
      if (!antecipacaoId || antecipacaoId === 0) {
        toast.warning('Esta é uma operação nova e ainda não possui histórico de logs.');
        return;
      }

      setProcessFlowAntecipacaoId(antecipacaoId);
      setProcessFlowFornecedorId(fornecedorId);
      setProcessFlowFornecedorNome(fornecedorNome);
      setOpenProcessFlowModal(true);
    } catch (error) {
      setMessageData(error?.response?.data?.complemento?.mensagensBox);
      handleErrorRequest(error.response);
    }
  }


  if ((!provider && !isLoading) || successSendPropose) {
    return (
      <S.TableTitleHeader>
        <h3 className="operation-title">Operação</h3>
      </S.TableTitleHeader>
    );
  }

  if (isLoading) {
    return (
      <>
        <S.TableTitleHeader>
          <h3 className="operation-title">Operação</h3>
        </S.TableTitleHeader>
        <Loading />
      </>
    );
  }

  return (
    <>
      {/* <S.OperationHeaderButtons>
        {!calcError.length > 0 && providerCalc?.controlesTela?.boxHistoricoConsultaPesquisa && (
          <Button
            variant="contained"
            disableElevation
            className="btn-text w-100"
            style={{ background: '#009688', color: '#fff' }}
          >
            Histórico – Consulta - Pesquisa
          </Button>
        )}
      </S.OperationHeaderButtons> */}
      {/* <S.OperationHeaderButtons>

      </S.OperationHeaderButtons> */}

      {confirmationBox.show && (
        <ConfirmationBox
          data={confirmationBox}
          setConfirmationBox={setConfirmationBox}
        ></ConfirmationBox>
      )}

      {confirmationRedeBox.show && (
        <ConfirmationBox
          data={confirmationRedeBox}
          setConfirmationBox={setConfirmationRedeBox}
          ></ConfirmationBox>
      )}

      {/* Modal de Esteira de Processos */}
      <ProcessFlowModal
        open={openProcessFlowModal}
        onClose={() => setOpenProcessFlowModal(false)}
        antecipacaoId={processFlowAntecipacaoId}
        fornecedorId={processFlowFornecedorId}
        fornecedorNome={processFlowFornecedorNome}
      />

      <S.OperationTableContainer>
        <div className="operation" style={{background: (providerCalc?.operacao?.antecipacaoStatus === 'Cancelada' ? '#fa8072' : (providerCalc?.operacao?.antecipacaoStatus === 'Recusada' ? '#ffa500' : providerCalc?.operacao?.antecipacaoStatus === 'Aprovada' ? '#b3e5fc' : '#fffff'))}}>
          <div className="title-header">
            {providerCalc?.operacao?.fornecedorFavorito ? (
              <Tooltip placement="top" title="Favorito">
                <StarIcon className="pointer" style={{ color: '#f0a918', paddingLeft: '10px' }} onClick={() => favoritarAncora(providerCalc?.operacao?.fornecedorFavorito )} />
              </Tooltip>
            ) : (
              <Tooltip placement="top" title="Não Favorito">
                <StarBorderIcon className="pointer" style={{ paddingLeft: '10px' }}  onClick={() => favoritarAncora(providerCalc?.operacao?.fornecedorFavorito )} />
              </Tooltip>
            )}
            <Tooltip placement="top" title="Informações" onClick={() => fetchInfo()}>
              <InfoIcon className="pointer" style={{ paddingLeft: '10px' }}  />
            </Tooltip>
            <Tooltip placement="top" title="Esteira de Processos" onClick={() => fetchLogsAntecipacoes()}>
              <HistoryIcon className="pointer" style={{ paddingLeft: '10px' }} />
            </Tooltip>
            <h3 className="operation-title">Operação {providerCalc?.operacao?.antecipacaoStatus} {providerCalc?.operacao?.antecipacaoId === 0 ? '' : providerCalc?.operacao?.antecipacaoId}{providerCalc?.operacao?.antecipacaoId === 0 ? '' : '-'}{providerCalc?.operacao?.antecipacaoId === 0 ? '' : providerCalc?.operacao?.ancoraId}  
            
               </h3>
            <Tooltip placement="top" title="Recarregar conteúdo">
              <CachedIcon className="pointer" onClick={() => handleReload()} />
            </Tooltip>
          </div>
          <div className="operation-content">
            <div className="left-content">
              <ContentContainer
                label="Fornecedor"
                value={providerCalc?.operacao?.fornecedor}
                hasTooltip
              />
              <ContentContainer label="CNPJ/CPF" value={providerCalc?.operacao?.cnpjCpf} />
              <ContentContainer
                label="Data Base"
                value={formatDateTimeToRender(providerCalc?.operacao?.dataBase)?.split(' ')?.[0]}
              />
              <ContentContainer label="Data Pagto">
                <div>
                  {providerCalc?.controlesTela?.botoesDataPagamento && (
                    <span
                      onClick={() => {
                        if (!isSameDay(new Date(providerCalc.operacao.dataPagamento), new Date())) {
                          recalculateOperation(true, false);
                        }
                      }}
                      className="pointer"
                    >
                      🢀
                    </span>
                  )}
                  <S.ArrowDateOption hasArrow={providerCalc?.controlesTela?.botoesDataPagamento}>
                    {formatDateWithoutHour(providerCalc?.operacao?.dataPagamento)}
                  </S.ArrowDateOption>
                  {providerCalc?.controlesTela?.botoesDataPagamento && (
                    <span
                      onClick={() => {
                        recalculateOperation(false, true);
                      }}
                      className="pointer"
                    >
                      🢂
                    </span>
                  )}
                </div>
              </ContentContainer>
              <ContentContainer
                label="Prazo Médio"
                value={`${providerCalc?.operacao?.prazoMedio} dia(s)`}
              />
              <ContentContainer
                label="Pagto"
                value={providerCalc?.operacao?.destinoPagamento ?
                  capitalizeFirstLetter(providerCalc.operacao.destinoPagamento) : ''}
              />
              <ContentContainer label="Ordem Títulos">
                {!providerCalc?.controlesTela?.comboOrdemDosTitulos ? (
                  <span>
                    {ordersTitle[providerCalc?.operacao?.ordemTitulos] ||
                      providerCalc?.operacao?.ordemTitulos}
                  </span>
                ) : (
                  <select
                    onChange={(e) => {
                      setNewSequency(e.target.value);
                      recalculateOperation(undefined, undefined, undefined, e.target.value);
                    }}
                    value={newSequency || providerCalc?.operacao?.ordemTitulos}
                    style={{ width: '55%' }}
                    disabled={!providerCalc?.controlesTela?.comboOrdemDosTitulos}
                  >
                    <option value="NumeroNotaFiscal">Número Nota Fiscal</option>
                    <option value="Sequencia">Sequência</option>
                    <option value="DataVencimento">Data Vencimento</option>
                    <option value="Loja">Loja</option>
                  </select>
                )}
              </ContentContainer>

              <ContentContainer label="Condição">
                {!providerCalc?.controlesTela?.comboCondicao ? (
                  <span>{providerCalc?.operacao?.condicao}</span>
                ) : (
                  <select
                    onChange={(e) => setNewCondition(e.target.value)}
                    value={newCondition || providerCalc?.operacao?.condicao}
                    style={{ width: '55%' }}
                    disabled={!providerCalc?.controlesTela?.comboCondicao}
                  >
                    <option value="Nenhum">Nenhum</option>
                    <option value="Taxa">Taxa</option>
                    <option value="Desagio">Deságio</option>
                    <option value="Ambos">Ambos</option>
                  </select>
                )}
              </ContentContainer>
              <ContentContainer
                hasHTML
                label="Conta Bancária"
                value={{ __html: providerCalc?.operacao?.dadosContaBancaria }}
              />
              <ContentContainer label="Contato Efetuado">
                {providerCalc?.operacao?.contatoEfetuado || contatoEfetuado ? ( 
                  <span>{moment(providerCalc?.operacao?.contatoEfetuado ? providerCalc.operacao.contatoEfetuado : contatoEfetuado).format('DD/MM/YYYY HH:mm')}</span>
                ) : (
                  <>
                  {(
                    !calcError.length > 0 &&
                    (((providerCalc?.controlesTela?.botaoEnviarProposta || providerCalc?.controlesTela?.botaoCancelarProposta|| providerCalc?.controlesTela?.botaoSubstituirProposta) && !changedValueTax)            
                    )) ? (
                      <Button
                        className="btn-smaller-text"
                        disableElevation
                        variant="contained"
                        color="primary"
                        style={{ background: '#ff7f26', color: '#fff', padding: '3px 8px' }}
                        onClick={async () => {
                          setIsLoading(true)
                          const contatoDate = await consultarDataHora()
                          if((providerCalc?.controlesTela?.botaoCancelarProposta|| providerCalc?.controlesTela?.botaoSubstituirProposta)) {
                            await atualizarContatoEfetuado(contatoDate)
                          }
                          setIsLoading(false)
                        }}
                      >
                        Registrar Contato
                      </Button>
                    ) : (
                      <span>Sem Contato Efetuado</span>
                    )}
                  </>
                )}
              </ContentContainer>
            </div>

            <div className="right-content">
              <ValuesPercentContentContainer
                label="Deságio"
                value={`${convertNumberPercent(providerCalc?.operacao?.desagio, 2)}`}
              />
              <ValuesPercentContentContainer
                label="Taxa"
                value={`${convertNumberPercent(providerCalc?.operacao?.taxa.toFixed(2), 2)}`}
              />

              <ValuesPercentContentContainer
                label="Valor Bruto"
                value={convertForRealFormatted(providerCalc?.operacao?.valorBruto, 2)}
              />
              <ValuesPercentContentContainer
                label="Desconto"
                value={convertForRealFormatted(providerCalc?.operacao?.valorDesconto, 2)}
              />
              <ValuesPercentContentContainer
                label="Valor a Pagar"
                value={convertForRealFormatted(providerCalc?.operacao?.valorLiquido, 2)}
              />

              {!calcError.length > 0 &&
                providerCalc?.controlesTela?.botaoEnviarProposta &&
                !changedValueTax && (
                  <Button
                    className="btn-text"
                    disableElevation
                    variant="contained"
                    color="primary"
                    disabled={isSendingOperation || isLoading}
                    style={{ background: '#689f38', color: '#fff' }}
                    onClick={() => handleConfirmationBox('confirmacao', sendOperationRequest)}
                  >
                    Enviar proposta
                  </Button>
                )}
              {changedValueTax && providerCalc?.controlesTela?.botaoEnviarProposta && (
                <S.FakeButton />
              )}
              {!calcError.length > 0 && providerCalc?.controlesTela?.botaoSubstituirProposta && (
                <Button
                  style={{ background: `${colors.gold}`, color: '#fff' }}
                  className="btn-text"
                  disableElevation
                  variant="contained"
                  color="secondary"
                  onClick={() => verificarRemessaPagamentoEContinuar('substituicao', () => handleConfirmationBox('substituicao', replaceOperation))}
                >
                  Substituir proposta
                </Button>
              )}
              {providerCalc?.controlesTela?.botaoCancelarProposta && (
                <Button
                  style={{ background: '#ff0000', color: '#fff' }}
                  className="btn-text"
                  disableElevation
                  variant="contained"
                  onClick={() => verificarRemessaPagamentoEContinuar('cancelamento', () => handleConfirmationBox('cancelamento',
                    providerCalc?.controlesTela?.botaoAprovarProposta ? fecharOperation : cancelOperation))}
                >
                  Cancelar proposta
                </Button>
              )}
              {providerCalc?.controlesTela?.botaoAplicarAbatimentosDescontos && (
                <Button
                  style={{ background: '#ff7f26', color: '#fff' }}
                  className="btn-text"
                  disableElevation
                  variant="contained"
                  onClick={() => handleConfirmationBox('aplicarAbatimentosDescontos', aplicarAntecipacoesDescontos)}
                >
                  Aplicar Abatimentos/Descontos
                </Button>
              )}
              {providerCalc?.controlesTela?.botaoAprovarProposta && (
                <Button
                  style={{ background: '#a349a3', color: '#fff' }}
                  className="btn-text"
                  disableElevation
                  variant="contained"
                  onClick={() => handleConfirmationBox('aprovacao', sendOperationRequest)}
                >
                  <span style={{ fontSize: '0.55vw' }}>
                    Aprovar Proposta Com<br />
                    Abatimentos/Descontos
                  </span>
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className="operation-calc" style={{background: (providerCalc?.operacao?.antecipacaoStatus === 'Cancelada' ? '#fa8072' : (providerCalc?.operacao?.antecipacaoStatus === 'Recusada' ? '#ffa500' : providerCalc?.operacao?.antecipacaoStatus === 'Aprovada' ? '#b3e5fc' : '#fffff'))}}>
          <h3 className="operation-title">Cálculos</h3>
          <div
            style={{
              height: providerCalc?.controlesTela?.boxCalculos &&
              !providerCalc?.controlesTela?.botaoAprovarProposta ? '100%' : '0px',
              top: providerCalc?.controlesTela?.boxCalculos &&
              !providerCalc?.controlesTela?.botaoAprovarProposta? 'auto' : '50px',
            }}
          >
            <Button
              style={{
                background: providerCalc?.bancoFidc?.alertarOperador
                  ? colors.danger
                  : colors.sanMarino,
                color: '#fff',
              }}
              className="btn-text"
              variant="contained"
              color="primary"
              disableElevation
              onClick={() => setOpen(true)}
            >
              Banco/FIDC
              <br />
              {convertNumberPercent(providerCalc?.bancoFidc?.taxaBanco, 2)}
            </Button>
            {(providerCalc?.controlesTela?.boxCalculos &&
            !providerCalc?.controlesTela?.botaoAprovarProposta ) && (
              <>
                <ValuesPercentContentContainer
                  label="Taxa"
                  style={{ position: 'relative', left: '5px' }}
                  column
                  fullWidth
                >
                  <CurrencyTextField
                    focus={focusTipoCalculo === 'Taxa'}
                    onFocus={() => {
                      setFocusTipoCalculo('Taxa')
                    }}
                    onBlur={() => {
                      setFocusTipoCalculo('')
                    }}
                    disabled={focusTipoCalculo != 'Taxa' && focusTipoCalculo != ''}
                    value={tipoCalculo == 'Taxa' ? Number(tax) || Number(providerCalc?.operacao?.taxa) : 0}
                    onChange={(event, value) => {
                      setTax(value);
                      setAmountPay('');
                      setDesagio('')
                      setDesconto('')
                      setTipoCalculo('Taxa');
                      setChangedValueTax(true);
                    }}
                    currencySymbol=""
                    maximumValue={'999.99'}
                    className="calc-input"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        setInputEnter(true);
                        recalculateOperation();
                      }
                    }}
                    inputProps={{ref:taxInput}}
                    placeholder=""
                    decimalCharacter=","
                    minimumValue="0"
                    modifyValueOnWheel={false}
                    digitGroupSeparator="."
                  />
                </ValuesPercentContentContainer>

                <ValuesPercentContentContainer
                  label="Deságio"
                  style={{ position: 'relative', left: '5px' }}
                  column
                  fullWidth
                >
                  <CurrencyTextField
                    focus={focusTipoCalculo === 'Desagio'}
                    inputProps={{ref:desagioInput}}
                    onFocus={() => {
                      setFocusTipoCalculo('Desagio')
                    }}
                    onBlur={() => {
                      setFocusTipoCalculo('')
                    }}
                    value={tipoCalculo == 'Desagio' ? Number(desagio) : 0}
                    disabled={focusTipoCalculo != 'Desagio' && focusTipoCalculo != ''}
                    onChange={(event, value) => {
                      setTax('');
                      setAmountPay('');
                      setDesconto('')
                      setDesagio(value)
                      setTipoCalculo('Desagio');
                      setChangedValueTax(true);
                    }}
                    currencySymbol=""
                    maximumValue={'999.99'}
                    className="calc-input"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        setInputEnter(true);
                        recalculateOperation();
                      }
                    }}
                    placeholder=""
                    decimalCharacter=","
                    minimumValue="0"
                    modifyValueOnWheel={false}
                    digitGroupSeparator="."
                  />
                </ValuesPercentContentContainer>

                <ValuesPercentContentContainer
                  label="Desconto"
                  style={{ position: 'relative', left: '5px' }}
                  column
                  fullWidth
                >
                  <CurrencyTextField
                    focus={focusTipoCalculo === 'Desconto'}
                    inputProps={{ref:descontoInput}}
                    onFocus={() => {
                      setFocusTipoCalculo('Desconto')
                    }}
                    onBlur={() => {
                      setFocusTipoCalculo('')
                    }}
                    value={tipoCalculo == 'Desconto' ? Number(desconto) : 0}
                    disabled={focusTipoCalculo != 'Desconto' && focusTipoCalculo != ''}
                    onChange={(event, value) => {
                      setTax('');
                      setAmountPay('');
                      setDesagio('')
                      setDesconto(value)
                      setTipoCalculo('Desconto');
                      setChangedValueTax(true);
                    }}
                    currencySymbol=""
                    maximumValue={'999999.99'}
                    className="calc-input"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        setInputEnter(true);
                        recalculateOperation();
                      }
                    }}
                    placeholder=""
                    decimalCharacter=","
                    minimumValue="0"
                    modifyValueOnWheel={false}
                    digitGroupSeparator="."
                  />
                </ValuesPercentContentContainer>

                <Button
                  className="btn-text"
                  variant="contained"
                  color="primary"
                  disableElevation
                  style={{
                    background: colors.sanMarino,
                    color: '#fff',
                  }}
                  onClick={() => recalculateOperation()}
                >
                  Recalcular
                </Button>
              </>
            )}
          </div>
          <Draggable handle='.tax-dialog-header'>
            <S.TaxDialog open={open} onClose={handleCloseFIDC} disableEscapeKeyDown hideBackdrop
            BackdropProps={{
              style: {
                width: '40%',
                height: '30%', // altura menor
                top: '35%', // centraliza vertical
                left: '30%' // centraliza horizontal
              }
            }}
            >
              <DialogContent style={{ cursor: 'default' }}>
                <DialogContentText style={{ cursor: 'default' }}>
                <div className="tax-dialog-header" style={{ cursor: 'grab' }}>
                    <span className="title-header">
                     Taxa do banco para equiparar a nossa oferta&nbsp;&nbsp;&nbsp;&nbsp;
                      {convertNumberPercent(providerCalc?.bancoFidc?.taxaBanco, 2)}
                    </span>
                  </div>
                  <S.JurosContainer>
                    {/* <div>
                      <div className="juros-bank">
                        <span className="juros-title w-50">Taxa banco</span>
                        <span className="juros-tax">{providerCalc?.bancoFidc?.taxaBanco}%</span>
                      </div>
                    </div> */}
                    <div>
                      <span className="juros-title">Juros</span>
                      <span className="juros-tax text-right">
                        {convertNumberPercent(providerCalc?.bancoFidc?.jurosTaxa, 2)}
                      </span>
                      <span className="juros-value text-right">
                        {convertForRealFormatted(providerCalc?.bancoFidc?.jurosValor, 2)}
                      </span>
                    </div>
                    <div>
                      <span className="juros-title">IOF</span>
                      <span className="juros-tax text-right">
                        {convertNumberPercent(providerCalc?.bancoFidc?.iofTaxa, 2)}
                      </span>
                      <span className="juros-value text-right">
                        {convertForRealFormatted(providerCalc?.bancoFidc?.iofValor, 2)}
                      </span>
                    </div>
                    <div>
                      <span className="juros-title">IOF ao Dia</span>
                      <span className="juros-tax text-right">
                        {convertForRealFormattedPrecise(providerCalc?.bancoFidc?.iofDiarioTaxa, 4,4)}
                      </span>
                      <span className="juros-value text-right">
                        {convertForRealFormatted(providerCalc?.bancoFidc?.iofDiarioValor, 2)}
                      </span>
                    </div>
                    <div>
                      <span className="juros-title">Tarifas</span>
                      <span className="juros-value text-right">
                        {convertForRealFormatted(providerCalc?.bancoFidc?.valorTarifaBancaria, 2)}
                      </span>
                    </div>
                    {/* <div className="total">
                      <span className="juros-title">Custo Efetivo</span>
                      <span className="juros-value">
                        {convertForRealFormatted(providerCalc?.bancoFidc?.custoEfetivo)}
                      </span>
                    </div> */}
                  </S.JurosContainer>
                     <div className="tax-dialog-header">
                    <div className="footer-title">
                      <span>Custo efetivo</span>
                    </div>
                    {convertForRealFormatted(providerCalc?.bancoFidc?.custoEfetivo, 2)}
                  </div>
                  {/* NOVAS TAXAS + NOVO IOF — ocultado a pedido (2026-08-10); manter código para reativar se necessário
                  <div className="tax-dialog-header" style={{ marginTop: '20px' }}>
                    <span className="title-header">
                      Novas Taxas + Novo IOF&nbsp;&nbsp;&nbsp;&nbsp;
                       {convertNumberPercent(providerCalc?.bancoFidcComparacao?.taxaBanco, 2)}
                    </span>
                  </div>

                  <S.JurosContainer>
                    <div>
                      <span className="juros-title">Juros</span>
                      <span className="juros-tax text-right">
                        {convertNumberPercent(providerCalc?.bancoFidcComparacao?.jurosTaxa, 2)}
                      </span>
                      <span className="juros-value text-right">
                        {convertForRealFormatted(providerCalc?.operacao?.valorDesconto, 2)}
                      </span>
                    </div>
                    <div>
                      <span className="juros-title">IOF</span>
                      <span className="juros-tax text-right">
                        {convertNumberPercent(providerCalc?.bancoFidcComparacao?.iofTaxa, 2)}
                      </span>
                      <span className="juros-value text-right">
                        {convertForRealFormatted(providerCalc?.bancoFidcComparacao?.iofValor, 2)}
                      </span>
                    </div>
                    <div>
                      <span className="juros-title">IOF ao Dia</span>
                      <span className="juros-tax text-right">
                        {convertForRealFormattedPrecise(providerCalc?.bancoFidcComparacao?.iofDiarioTaxa, 4,4)}
                      </span>
                      <span className="juros-value text-right">
                        {convertForRealFormatted(providerCalc?.bancoFidcComparacao?.iofDiarioValor, 2)}
                      </span>
                    </div>
                    <div>
                      <span className="juros-title">Tarifas</span>
                      <span className="juros-value text-right">
                        {convertForRealFormatted(providerCalc?.bancoFidcComparacao?.valorTarifaBancaria, 2)}
                      </span>
                    </div>
                  </S.JurosContainer>
                  <div className="tax-dialog-header">
                    <div className="footer-title">
                      <span>Custo efetivo</span>
                    </div>
                    {convertForRealFormatted(providerCalc?.bancoFidcComparacao?.custoEfetivo, 2)}
                  </div>
                  */}
              </DialogContentText>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setOpen(false)}
                  color="primary"
                  style={{
                    background: colors.sanMarino,
                    color: '#fff',
                  }}
                >
                  Fechar
                </Button>
              </DialogActions>
            </S.TaxDialog>
          </Draggable>
        </div>
      </S.OperationTableContainer>
    </>
  );
}

export default OperationTable;
